












































































































































import ISystemSettings from '@/store/models/ISystemSettings';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class SystemSettingsSelector extends Vue {
    searchSystemSettings: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'KeySetting', value: 'keySettings' },
        { text: 'Description', value: 'description' },
        { text: 'Value', value: 'value' }
    ];
    editedIndex : number = -1;
    editedItem : ISystemSettings = {
        id: "",
        keySettings: "",
        description: "",
        value: ""
    }
    defaultItem : ISystemSettings = {
        id: "",
        keySettings: "",
        description: "",
        value: ""
    }
    sortBy: string = 'keySettings';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    SystemSettingsList !: ISystemSettings[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedSystemSettings : ISystemSettings[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New System Setting' : 'Edit System Setting'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetSystemSettingss() {
        this.selectedSystemSettings = [];
    }

    editSystemSettings (item: any, dbox = true) {
        this.editedIndex = this.SystemSettingsList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveSystemSettings (country: ISystemSettings) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedSystemSettings[0]) {
                this.close();
                this.$emit('editSystemSettings', this.editedItem);
                Object.assign(this.SystemSettingsList[this.editedIndex], this.editedItem);
            } else {
                this.selectedSystemSettings[0] = this.editedItem;
                this.$emit('saveSystemSettings', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteSystemSettings (country: ISystemSettings) {
        this.$emit('deleteSystemSettings', country);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectSystemSettings(item : any) : void {
        if (!this.selectedSystemSettings.includes(item)) {
            this.selectedSystemSettings = [];
            this.selectedSystemSettings = [item];
        } else {
            this.selectedSystemSettings = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
